// extracted by mini-css-extract-plugin
export default {"wrapper":"ActivityStepper_wrapper__h2dvN","singleStep":"ActivityStepper_singleStep__XP-zm","likeAnimation":"ActivityStepper_likeAnimation__-2xXi"};